import {
  $fontWeightBold,
  $fontWeightLight,
  styled,
  $error
} from "@acko-tech/building-blocks.ui.common";
import { $fontSize } from "@acko-tech/building-blocks.ui.common";

import { Text } from "@acko-tech/building-blocks.ui.typography";
// import Button from "@acko-tech/building-blocks.ui.button-old";
import BikeFormItem from "./common/BikeFormItem";

import {
  PRIMARY_ACCENT,
  TEXT_COLOR,
  BORDER_COLORS,
  ERROR_ACCENT
} from "@utils/bike/bikeConstants";

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 50px);
  padding-bottom: 145px;
  & > * {
    flex-shrink: 0;
  }
`;

export const BikeRegNo = styled.div`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: #000000;

  & > span {
    color: #0091dd;
    font-weight: bold;
    margin: 0 0 0 2px;
    cursor: pointer;
  }
`;

export const TermConText = styled.div`
  color: #5b5675;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  & > span > a {
    color: #1b73e8;
    text-decoration: none;
  }
`;

export const Heading = styled.div`
  font-weight: ${$fontWeightBold};
  font-size: ${$fontSize.small};
  line-height: 24px;
  color: #040222;
`;

export const PhonInfoLable = styled(Text)`
  font-style: normal;
  font-weight: ${$fontWeightLight};
  font-size: ${$fontSize.xxs};
  line-height: 16px;
  color: #5b5675;
`;

export const Seperator = styled.div`
  width: 100%;
  border-bottom: 3px solid #f8f7fc;
`;

export const Info = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.03em;
  color: #414a53;
  width: 70%;
  margin: 0 auto;
`;

export const Error = styled(Text)`
  color: ${$error};
  text-align: left;
  // margin-right: 0;
  // padding-right: 0.75rem;
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  // margin-left: 0px;
  margin: 8px 8px 8px 0px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  background-color: #fff;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 20px;
`;

export const HeaderText = styled(Text)`
  font-size: ${$fontSize.xxs};
  color: ${PRIMARY_ACCENT.DARK};
`;

export const BannerText = styled(Text)`
  font-weight: bold;
  font-size: ${$fontSize.medium};
  color: ${TEXT_COLOR.DARKER};
  flex: 1;
  margin-top: 12px;
`;

export const BikeImage = styled.img`
  width: 172px;
  display: block;
  height: auto;
  margin: 0 auto;
`;

export const BikeName = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #414a53;
  margin: 20px 0;
  display: grid;
  grid-template-columns: 1fr 25px;
  grid-gap: 5px;
  justify-content: center;
  align-items: center;
  word-break: break-word;

  & > span {
    word-break: break-word;
  }
`;

export const Edit = styled.img`
  height: 20px;
  width: 20px;
  cursor: pointer;
  margin: 0 0 0 5px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* position: relative; */

  & > * {
    flex-shrink: 0;
  }
`;

export const SearchButton = styled.div`
  height: 60px;
  padding: 20px 10px 20px 20px;
  border: 1px solid ${BORDER_COLORS.NORMAL};
  border-radius: 10px;
  display: flex;
  align-items: center;
`;

export const SearchButtonText = styled(Text)`
  flex: 1;
  color: ${TEXT_COLOR.LIGHT};
  font-size: ${$fontSize.normal};
`;

export const SearchButtonIcon = styled.img`
  width: 40px;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  margin: auto;
`;

export const StyledBikeFormitem = styled(BikeFormItem)<{
  hideExpiry?: boolean;
}>`
  padding: ${props => (props.hideExpiry ? "10px 20px" : " 0")};
`;

// export const ViewPricesButton = styled(Button)`
//   background-color: ${PRIMARY_ACCENT.NORMAL};
//   margin-top: 18px;
//   width: 155px;
//   margin: 30px auto 10px auto;
//   padding: 8px;

//   &:hover {
//     background-color: ${PRIMARY_ACCENT.NORMAL};
//   }
// `;

export const NotMyBike = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #000;
  margin: 20px auto;
  text-align: center;

  & > span {
    color: #0091dd;
    margin: 0 0 0 5px;
  }
`;

export const SectionHeading = styled(Text)`
  font-weight: 600;
  color: ${TEXT_COLOR.LIGHT};
`;

export const RatingsAndReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  margin-top: 8px;
  padding: 20px 0px;
`;

export const ModalHeading = styled(SectionHeading)`
  text-align: ${props => (props.centerAlign ? "center" : "default")};
  font-size: 18px;
  line-height: 24px;
`;

export const ErrorText = styled(Text)`
  font-size: ${$fontSize.xxs};
  color: ${ERROR_ACCENT};
  font-weight: 500;
  margin-top: 12px;
  padding: 0 20px;
`;

export const CloseIcon = styled.img`
  height: 15px;
  width: 15px;
`;

export const CloseText = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #282e33;
`;

export const BrowserBack = styled.img`
  height: 15px;
  width: 15px;
  position: absolute;
  top: 20px;
  left: 20px;
`;

export const StickyContainer = styled.div`
  ${props => props.nonSticky && ``}
  ${props =>
    !props.nonSticky &&
    `position: fixed;
  bottom:0;
  left:0;
  box-shadow: ${props =>
    !props.noShadow ? "0px -2px 4px rgba(32, 35, 44, 0.05);" : "none;"}
  box-sizing:border-box;
  padding:20px;
  width:100%;
  background-color:white;`}
  bottom: ${props => (props.bottom ? props.bottom : 0)};
  z-index: 1;
  width:100%;
  }
`;

export const ErrLabel = styled.span`
  font-size: 12px;
  color: ${ERROR_ACCENT};
  margin: 8px 8px 8px 0px;
`;
